import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, AdditionalNavItem } from '@sitebase/web-shell-kit';
import { SETTINGS_RENDERER_TYPE } from '../../rendererTypes';

export const SettingsMenu = (props) => {
  const { id, label, children } = props;

  return (
    <AdditionalNavItem id={id} label={label} data-test-id={`${SETTINGS_RENDERER_TYPE}_${id}`}>
      <Drawer data-test-id={`${SETTINGS_RENDERER_TYPE}.dropdown_${id}`}>{children}</Drawer>
    </AdditionalNavItem>
  );
};

const dataPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.shape(React.children)),
};
SettingsMenu.propTypes = dataPropTypes;

const renderFunction = ({ data, children }, runRenderer) => (
  <SettingsMenu {...data}>{children.map((child) => runRenderer(child))}</SettingsMenu>
);

renderFunction.propTypes = {
  data: PropTypes.shape(dataPropTypes),
  children: PropTypes.node,
};

const buildSettingsMenuRenderer = () => ({
  type: SETTINGS_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const SettingsMenuRenderer = buildSettingsMenuRenderer();

export default SettingsMenuRenderer;
